import httpService from "./httpService";
import documentRouteStatus from "../constants/documentRouteStatus";

export default {
  getRejectedInvoices: () =>
    httpService.get(`/documentstatus?documentTypeId=93&documentRouteStatusId=${documentRouteStatus.Rejected}`),
  getCounts: () => httpService.get(`/documentstatus/counts`),
};
